import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const MENU_ITEMS = [
  { section: 'ANA MENU', items: [
    { path: '/', icon: '\u{1F3E0}', label: 'Dashboard' },
    { path: '/purchases', icon: '\u{1F6D2}', label: 'Alımlar' },
    { path: '/sales', icon: '\u{1F4B0}', label: 'Satışlar' },
    { path: '/harvest', icon: '\u{1F33E}', label: 'Hasat' },
    { path: '/work-orders', icon: '\u{1F4CB}', label: 'İş Emirleri' },
    { path: '/yevmiyeler', icon: '\u{1F477}', label: 'Yevmiyeler' },
    { path: '/plantings', icon: '\u{1F331}', label: 'Ekim Kayıtları' },
    { path: '/notebook', icon: '\u{1F4D3}', label: 'Notlar' },
    { path: '/stock', icon: '\u{1F4E6}', label: 'Stok' },
  ]},
  { section: 'TANIM VE AYARLAR', items: [
    { path: '/contacts', icon: '\u{1F465}', label: 'Kişiler' },
    { path: '/payments', icon: '\u{1F4B3}', label: 'Ödemeler' },
    { path: '/settings', icon: '⚙️', label: 'Ayarlar' },
  ]},
];

export default function BurgerMenu({ isOpen, onClose }) {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleNav = (path) => {
    onClose();
    navigate(path);
  };

  const handleLogout = () => {
    onClose();
    logout();
    navigate('/login');
  };

  return (
    <>
      {/* Overlay */}
      {isOpen && (
        <div onClick={onClose} style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          background: 'rgba(0,0,0,0.5)', zIndex: 998,
        }} />
      )}
      {/* Drawer */}
      <div style={{
        position: 'fixed', top: 0, left: 0, bottom: 0, width: 280,
        background: '#fff', zIndex: 999, boxShadow: '4px 0 24px rgba(0,0,0,0.15)',
        transform: isOpen ? 'translateX(0)' : 'translateX(-280px)',
        transition: 'transform 0.25s ease',
        display: 'flex', flexDirection: 'column',
        overflowY: 'auto',
      }}>
        {/* Header */}
        <div style={{ padding: '24px 16px 16px', background: 'var(--green-dark)', color: '#fff' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
            <span style={{ fontSize: '1.5rem' }}>{'\u{1F331}'}</span>
            <span style={{ fontFamily: 'Playfair Display', fontSize: '1.2rem', fontWeight: 700 }}>Teldolap</span>
          </div>
          <div style={{ fontWeight: 700, fontSize: '1rem' }}>{user?.farmName}</div>
          <div style={{ fontSize: '0.78rem', opacity: 0.7 }}>{user?.name} {'·'} {user?.role}</div>
        </div>

        {/* Menu sections */}
        <div style={{ flex: 1, padding: '8px 0' }}>
          {MENU_ITEMS.map(section => (
            <div key={section.section}>
              <div style={{ padding: '12px 16px 4px', fontSize: '0.68rem', fontWeight: 700, color: '#aaa', letterSpacing: '0.05em' }}>
                {section.section}
              </div>
              {section.items.map(item => (
                <div key={item.path} onClick={() => handleNav(item.path)}
                  style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 16px', cursor: 'pointer', fontSize: '0.88rem' }}
                  onMouseEnter={e => e.currentTarget.style.background = 'var(--green-pale)'}
                  onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                  <span style={{ fontSize: '1.1rem' }}>{item.icon}</span>
                  <span style={{ fontWeight: 600 }}>{item.label}</span>
                </div>
              ))}
            </div>
          ))}

          {/* Reports (greyed out) */}
          <div style={{ padding: '12px 16px 4px', fontSize: '0.68rem', fontWeight: 700, color: '#aaa', letterSpacing: '0.05em' }}>
            RAPORLAR
          </div>
          {[['\u{1F4CA}','Sezon Raporu'],['\u{1F4B9}','Kâr / Zarar'],['\u{1F33E}','Ürün Analizi']].map(([i,l]) => (
            <div key={l} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 16px', opacity: 0.4 }}>
              <span style={{ fontSize: '1.1rem' }}>{i}</span>
              <span style={{ fontWeight: 600, fontSize: '0.88rem' }}>{l}</span>
              <span style={{ marginLeft: 'auto', fontSize: '0.65rem', background: '#eee', padding: '1px 6px', borderRadius: 4, fontWeight: 700 }}>Yak{'ı'}nda</span>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div style={{ padding: '12px 16px', borderTop: '1px solid #eee' }}>
          <div style={{ fontSize: '0.72rem', color: '#ccc', marginBottom: 8 }}>v1.0</div>
          <button onClick={handleLogout}
            style={{ background: 'none', border: 'none', color: '#e74c3c', fontWeight: 700, fontSize: '0.85rem', cursor: 'pointer', padding: 0 }}>
            {'\u{1F6AA}'} {'Çıkış'} Yap
          </button>
        </div>
      </div>
    </>
  );
}
